(function () {
  'use strict';

  if (window.__gmPromoKeyboardDismissal || !window.MutationObserver) return;
  window.__gmPromoKeyboardDismissal = true;

  var script = document.currentScript;
  var closeLabel = script ? (script.getAttribute('data-gm-close-label') || '').trim() : '';
  var hostName = 'CT-WEB-POPUP-IMAGEONLY';
  var creativeOrigin = 'https://d1510fwumr3byl.cloudfront.net';
  var creativePath = '/dist/1772703616/i/6a662635df924b1294520fe1b721caa4.jpeg';
  var records = new Map();
  var rootRetryLimit = 12;
  var focusOwner = null;
  var editing = null;
  var browsingByTab = false;
  var openingDialogs = new Set();

  function matchedClose(record) {
    var host = record.host;
    var root = record.root;
    if (!host.isConnected || host.tagName !== hostName || !root ||
        host.shadowRoot !== root || root.mode !== 'open') return null;
    var container = root.getElementById('container');
    var close = root.getElementById('close');
    var image = root.getElementById('imageOnlyPopup');
    if (!container || container.getAttribute('role') !== 'dialog' ||
        !close || close.tagName !== 'DIV' || !container.contains(close) ||
        !image || image.tagName !== 'IMG' || !container.contains(image)) return null;
    try {
      var source = image.currentSrc || image.getAttribute('src') || image.src;
      var url = new URL(source, document.baseURI);
      if (url.origin !== creativeOrigin || url.pathname !== creativePath) return null;
    } catch (error) {
      return null;
    }
    return close;
  }

  function activeElement() {
    var active = document.activeElement;
    while (active && active.shadowRoot && active.shadowRoot.activeElement) {
      active = active.shadowRoot.activeElement;
    }
    return active;
  }

  function visible(node) {
    if (!node || !node.isConnected || !node.getClientRects().length) return false;
    var current = node;
    while (current && current.nodeType === 1) {
      var style = window.getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden' ||
          style.visibility === 'collapse' || style.opacity === '0' ||
          current.hasAttribute('hidden') || current.hasAttribute('inert') ||
          current.getAttribute('aria-hidden') === 'true') return false;
      current = current.parentElement || (current.getRootNode().host || null);
    }
    return true;
  }

  function shown(record) {
    var close = matchedClose(record);
    var image = record.root && record.root.getElementById('imageOnlyPopup');
    var container = record.root && record.root.getElementById('container');
    return document.visibilityState !== 'hidden' && close && visible(close) &&
      container && container.getAttribute('aria-modal') === 'true' &&
      image && image.complete && image.naturalWidth > 0 && visible(image);
  }

  // Keep only ownership references and intent, never field contents or key history.
  function editorContext(node) {
    if (!node || !node.isConnected || !node.matches || node.disabled || !visible(node) ||
        !node.matches('input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="reset"]), textarea, select, [contenteditable="true"]')) return null;
    var form = node.form || node.closest('form');
    if (!form || form.tagName !== 'FORM' || !form.isConnected) return null;
    var group = node.closest('[data-gm-pooja-fields]');
    if (group) {
      var owner = group.getAttribute('data-gm-pooja-form');
      if (!owner || form.getAttribute('id') !== owner || document.getElementById(owner) !== form || node.form !== form) return null;
      return { editor: node, form: form, group: group };
    }
    var id = form.getAttribute('id');
    group = node.closest('[data-calc-root]');
    if (id === 'gemstoneForm' || id === 'braceletForm' || id === 'astrologyForm' ||
        group && group.contains(form)) return { editor: node, form: form, group: group || form };
    var productType = form.querySelector('input[type="hidden"][name="form_type"][value="product"]');
    if (/^properties\[[^\]]+\]$/.test(node.getAttribute('name') || '') && node.form === form &&
        id && !/\s/.test(id) && document.getElementById(id) === form &&
        productType && productType.form === form && !productType.disabled) {
      return { editor: node, form: form, group: form };
    }
    if (form.querySelector('input[name="form_type"][value="contact"], input[name="form_type"][value="customer_login"], input[name="form_type"][value="create_customer"], input[name="form_type"][value="recover_customer_password"], input[name="form_type"][value="reset_customer_password"], input[name="form_type"][value="activate_customer_password"], input[name="form_type"][value="customer"]')) {
      return { editor: node, form: form, group: form };
    }
    return null;
  }

  function clearEditing() {
    editing = null;
    records.forEach(function (record) { record.restoreEditing = null; });
  }

  function editingContext() {
    if (!editing) return null;
    var current = editorContext(editing.editor);
    if (current && current.form === editing.form && current.group === editing.group) return editing;
    // Variant rerenders replace the owned Pooja group. Rebind only the same product/form/field.
    var oldGroup = editing.group;
    var fieldId = editing.editor.getAttribute('id');
    var owner = oldGroup.getAttribute('data-gm-pooja-form');
    var product = oldGroup.getAttribute('data-product-id');
    if (fieldId && owner && product && oldGroup.hasAttribute('data-gm-pooja-fields')) {
      var replacement = Array.from(document.querySelectorAll('[data-gm-pooja-fields]')).find(function (group) {
        return group.getAttribute('data-gm-pooja-form') === owner && group.getAttribute('data-product-id') === product;
      });
      var field = replacement && Array.from(replacement.querySelectorAll('input, textarea, select, [contenteditable="true"]')).find(function (node) {
        return node.getAttribute('id') === fieldId;
      });
      current = editorContext(field);
      if (current && current.form.getAttribute('id') === editing.form.getAttribute('id')) {
        editing.editor = current.editor;
        editing.form = current.form;
        editing.group = current.group;
        return editing;
      }
    }
    clearEditing();
    return null;
  }

  function rememberEditor(node) {
    var context = editorContext(node);
    if (!context) return;
    var previous = editingContext();
    if (previous && previous.form === context.form && previous.group === context.group) {
      previous.editor = context.editor;
    } else {
      clearEditing();
      editing = context;
    }
  }

  function withinEditing(node) {
    var context = editingContext();
    if (!context || !node || !node.nodeType) return false;
    var picker = context.editor.datepicker && context.editor.datepicker.pickerElement;
    return context.group.contains(node) || context.form.contains(node) ||
      node.form === context.form || picker && picker.isConnected && picker.contains(node);
  }

  function withinPromo(node) {
    var inside = false;
    records.forEach(function (record) {
      if (node === record.host || record.root && record.root.contains(node)) inside = true;
    });
    return inside;
  }

  function dialogNode(node) {
    return node && node.nodeType === 1 && (node.tagName === 'DIALOG' ||
      node.getAttribute('role') === 'dialog' || node.getAttribute('role') === 'alertdialog');
  }

  function otherDialogOwnsFocus(record) {
    var current = activeElement();
    while (current && current.nodeType === 1) {
      var role = current.getAttribute('role');
      if ((role === 'dialog' || role === 'alertdialog' ||
           current.tagName === 'DIALOG' && current.hasAttribute('open')) &&
          current !== record.host && (!record.root || !record.root.contains(current)) && visible(current)) return true;
      current = current.parentElement || (current.getRootNode().host || null);
    }
    var priority = false;
    openingDialogs.forEach(function (dialog) {
      if (!dialog.isConnected) openingDialogs.delete(dialog);
      else if (dialog !== record.host && (!record.root || !record.root.contains(dialog))) priority = true;
    });
    if (priority) return true;
    return Array.from(document.querySelectorAll('dialog[open], [role="dialog"][open], [role="alertdialog"][open], [role="dialog"][aria-modal="true"], [role="alertdialog"][aria-modal="true"], #shopify-pc__prefs__dialog')).some(function (modal) {
      return modal !== record.host && (!record.root || !record.root.contains(modal)) && visible(modal);
    });
  }

  function dismissed(record) {
    if (!record.host.isConnected) return true;
    // A fade or a new visible creative does not prove that native Close dismissed the modal.
    var dialogs = record.root ? Array.from(record.root.querySelectorAll('#container, [role="dialog"], [role="alertdialog"], dialog[open]')) : [];
    if (!dialogs.length && record.root) dialogs = Array.from(record.root.children).filter(function (node) {
      return !/^(STYLE|SCRIPT|LINK|TEMPLATE)$/.test(node.tagName);
    });
    return !dialogs.some(function (dialog) {
      var current = dialog;
      while (current && current.nodeType === 1) {
        var style = window.getComputedStyle(current);
        if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' ||
            current.hasAttribute('hidden') || current.hasAttribute('inert') || current.getAttribute('aria-hidden') === 'true') return false;
        current = current.parentElement || (current.getRootNode().host || null);
      }
      return dialog.isConnected;
    });
  }

  function restoreEditorAfterDismissal(record) {
    if (!dismissed(record)) return;
    // Retained nodes may be reused by the provider after an observed native dismissal.
    record.conflictCloses.clear();
    var context = record.restoreEditing;
    if (!context || document.visibilityState === 'hidden') return;
    if (context !== editingContext()) { record.restoreEditing = null; return; }
    if (otherDialogOwnsFocus(record)) return;
    record.restoreEditing = null;
    var active = activeElement();
    var inside = active && (active === record.host || record.root && record.root.contains(active));
    if ((inside || active === document.body || !active) && visible(context.editor) && !context.editor.disabled) {
      context.editor.focus({ preventScroll: true });
    }
  }

  function conflictGate(record) {
    restoreEditorAfterDismissal(record);
    var context = editingContext();
    var busy = false;
    try { busy = !!(window.gmPurchase && typeof window.gmPurchase.isBusy === 'function' && window.gmPurchase.isBusy()); } catch (error) {}
    if (!context && !busy && !otherDialogOwnsFocus(record)) return false;
    releaseFocus(record, false);
    var close = matchedClose(record);
    if (close && shown(record) && !record.conflictCloses.has(close)) {
      record.conflictCloses.add(close);
      record.restoreEditing = context;
      close.click();
      queueRefresh(record);
    }
    return true;
  }

  function releaseFocus(record, restore) {
    if (!record.focusManaged) return;
    var owned = focusOwner === record;
    var previous = record.returnFocus;
    var active = activeElement();
    var inside = active && (active === record.host || active === record.close ||
      record.root && record.root.contains(active));
    record.focusManaged = false;
    record.returnFocus = null;
    if (owned) focusOwner = null;
    if (!restore || !owned || otherDialogOwnsFocus(record) ||
        !(inside || active === document.body || !active)) return;
    if (previous && previous !== document.body && !previous.disabled && visible(previous)) {
      previous.focus({ preventScroll: true });
      if (activeElement() === previous || otherDialogOwnsFocus(record)) return;
    }
    var main = document.getElementById('main');
    if (!visible(main)) return;
    var before = main.getAttribute('tabindex');
    if (before === null) main.setAttribute('tabindex', '-1');
    main.focus({ preventScroll: true });
    if (before === null && main.getAttribute('tabindex') === '-1') main.removeAttribute('tabindex');
  }

  function manageFocus(record, close) {
    if (conflictGate(record)) return;
    if (!shown(record)) {
      releaseFocus(record, true);
      return;
    }
    if (otherDialogOwnsFocus(record)) return;
    var active = activeElement();
    if (!record.focusManaged) {
      record.returnFocus = record.root.contains(active) ? null : active;
      record.focusManaged = true;
    }
    focusOwner = record;
    if (!record.root.contains(active)) close.focus({ preventScroll: true });
    if (!record.root.contains(activeElement())) releaseFocus(record, false);
  }

  function tabControls(record) {
    var container = record.root.getElementById('container');
    return Array.from(container.querySelectorAll('a[href], button, input, select, textarea, [tabindex]'))
      .filter(function (node) { return node.tabIndex >= 0 && !node.disabled && visible(node); })
      .sort(function (a, b) {
        if (a.tabIndex > 0 && b.tabIndex > 0) return a.tabIndex - b.tabIndex;
        if (a.tabIndex > 0) return -1;
        if (b.tabIndex > 0) return 1;
        return 0;
      });
  }

  function restoreSemantics(record) {
    record.patches.forEach(function (patch) {
      if (patch.node.getAttribute(patch.name) !== patch.value) return;
      if (patch.before === null) patch.node.removeAttribute(patch.name);
      else patch.node.setAttribute(patch.name, patch.before);
    });
    record.patches = [];
    record.close = null;
  }

  function addMissingAttribute(record, close, name, value) {
    var before = close.getAttribute(name);
    if (before !== null && before.trim() !== '') return;
    if (before === value) return;
    record.patches = record.patches.filter(function (patch) {
      return patch.node !== close || patch.name !== name;
    });
    record.patches.push({ node: close, name: name, before: before, value: value });
    close.setAttribute(name, value);
  }

  function refresh(record) {
    if (record.disposed) return;
    restoreEditorAfterDismissal(record);
    var close = matchedClose(record);
    if (close !== record.close) restoreSemantics(record);
    if (!close) {
      releaseFocus(record, false);
      return;
    }
    record.close = close;
    addMissingAttribute(record, close, 'role', 'button');
    addMissingAttribute(record, close, 'tabindex', '0');
    if (closeLabel) addMissingAttribute(record, close, 'aria-label', closeLabel);
    var container = record.root.getElementById('container');
    if (!container.getAttribute('aria-labelledby')) addMissingAttribute(record, container, 'aria-label', 'GemsMantra offer');
    manageFocus(record, close);
  }

  function queueRefresh(record) {
    if (record.disposed || record.queued) return;
    record.queued = true;
    Promise.resolve().then(function () {
      record.queued = false;
      refresh(record);
    });
  }

  function onKeydown(record, event) {
    if (conflictGate(record)) return;
    if (event.defaultPrevented || event.isComposing ||
        event.altKey || event.ctrlKey || event.metaKey || otherDialogOwnsFocus(record)) return;
    var close = matchedClose(record);
    var active = record.root && record.root.activeElement;
    if (!close || !active || !active.isConnected || !record.root.contains(active)) return;
    if (event.key === 'Tab' && record.focusManaged && focusOwner === record && shown(record)) {
      var controls = tabControls(record);
      var index = controls.indexOf(active);
      var next = event.shiftKey ? index - 1 : index + 1;
      if (index < 0) next = event.shiftKey ? controls.length - 1 : 0;
      event.preventDefault();
      event.stopImmediatePropagation();
      (controls[(next + controls.length) % controls.length] || close).focus({ preventScroll: true });
      return;
    }
    if (event.repeat || event.shiftKey) return;
    var closeFocused = active === close || close.contains(active);
    var escape = event.key === 'Escape';
    var activate = closeFocused && (event.key === 'Enter' || event.key === ' ');
    if (!escape && !activate) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    close.click();
  }

  function detachRoot(record) {
    restoreEditorAfterDismissal(record);
    releaseFocus(record, !record.host.isConnected);
    if (record.observer) record.observer.disconnect();
    if (record.root) {
      record.root.removeEventListener('keydown', record.keydown, true);
      record.root.removeEventListener('load', record.load, true);
      record.root.removeEventListener('transitionend', record.load, true);
      record.root.removeEventListener('animationend', record.load, true);
    }
    restoreSemantics(record);
    record.root = null;
    record.observer = null;
  }

  function attachRoot(record) {
    if (record.disposed || !record.host.isConnected) return;
    var root = record.host.shadowRoot;
    if (!root || root.mode !== 'open') {
      if (!record.retryTimer && record.retries < rootRetryLimit) {
        record.retries += 1;
        record.retryTimer = window.setTimeout(function () {
          record.retryTimer = null;
          attachRoot(record);
        }, 250);
      }
      return;
    }
    if (record.retryTimer) {
      window.clearTimeout(record.retryTimer);
      record.retryTimer = null;
    }
    if (record.root !== root) {
      detachRoot(record);
      record.root = root;
      record.keydown = function (event) { onKeydown(record, event); };
      record.load = function () { queueRefresh(record); };
      root.addEventListener('keydown', record.keydown, true);
      root.addEventListener('load', record.load, true);
      root.addEventListener('transitionend', record.load, true);
      root.addEventListener('animationend', record.load, true);
      record.observer = new MutationObserver(function () { queueRefresh(record); });
      record.observer.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['id', 'src', 'srcset', 'role', 'aria-label', 'aria-labelledby', 'aria-modal', 'aria-hidden', 'tabindex', 'style', 'class', 'hidden', 'inert', 'disabled']
      });
    }
    refresh(record);
  }

  function register(host) {
    if (!host.isConnected || host.tagName !== hostName) return;
    var record = records.get(host);
    if (!record) {
      record = {
        host: host, root: null, observer: null, close: null, patches: [],
        retries: 0, retryTimer: null, queued: false, disposed: false,
        focusManaged: false, returnFocus: null, restoreEditing: null, conflictCloses: new Set()
      };
      records.set(host, record);
    }
    attachRoot(record);
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === hostName) register(node);
    node.querySelectorAll('ct-web-popup-imageonly').forEach(register);
  }

  function removeDetached() {
    records.forEach(function (record, host) {
      if (host.isConnected) return;
      record.disposed = true;
      if (record.retryTimer) window.clearTimeout(record.retryTimer);
      record.retryTimer = null;
      detachRoot(record);
      records.delete(host);
    });
  }

  var documentObserver = new MutationObserver(function (mutations) {
    if (editing && mutations.some(function (mutation) {
      return mutation.type === 'attributes' &&
        (mutation.target === editing.group &&
          (mutation.attributeName === 'data-product-id' || mutation.attributeName === 'data-gm-pooja-form') ||
         mutation.target === editing.form && mutation.attributeName === 'id') &&
        mutation.oldValue !== mutation.target.getAttribute(mutation.attributeName);
    })) clearEditing();
    editingContext();
    removeDetached();
    mutations.forEach(function (mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(scan);
        records.forEach(queueRefresh);
      } else {
        var target = mutation.target;
        var role = target.getAttribute('role');
        var dialogChanged = target.tagName === 'DIALOG' || role === 'dialog' || role === 'alertdialog' || target.getAttribute('id') === 'shopify-pc__prefs__dialog';
        records.forEach(function (record) {
          if (dialogChanged || editing || target === record.host || target.contains(record.host)) queueRefresh(record);
        });
      }
    });
  });
  documentObserver.observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeOldValue: true,
    attributeFilter: ['style', 'class', 'hidden', 'inert', 'aria-hidden', 'aria-modal', 'open', 'id', 'form', 'name', 'data-gm-pooja-form', 'data-product-id']
  });
  document.addEventListener('pointerdown', function (event) {
    var node = event.composedPath ? event.composedPath()[0] : event.target;
    var label = node && node.closest && node.closest('label');
    var editor = editorContext(node) ? node : label && label.control;
    if (editorContext(editor)) rememberEditor(editor);
    else if (!withinEditing(node) && !withinPromo(node)) clearEditing();
    records.forEach(queueRefresh);
  }, true);
  document.addEventListener('focusin', function () {
    var active = activeElement();
    rememberEditor(active);
    if (browsingByTab && !withinEditing(active) && !withinPromo(active)) clearEditing();
    browsingByTab = false;
    records.forEach(conflictGate);
    var record = focusOwner;
    if (!record) { records.forEach(queueRefresh); return; }
    if (conflictGate(record) || !shown(record)) return;
    if (!record.root.contains(activeElement())) matchedClose(record).focus({ preventScroll: true });
  }, true);
  document.addEventListener('keydown', function (event) {
    var active = activeElement();
    if (!event.defaultPrevented && !event.isComposing && event.key === 'Tab' && !withinPromo(active)) {
      if (withinEditing(active)) {
        browsingByTab = true;
        window.setTimeout(function () { browsingByTab = false; }, 0);
      } else clearEditing();
    }
    records.forEach(conflictGate);
    var record = focusOwner;
    if (!record || conflictGate(record) || !shown(record) ||
        record.root.contains(activeElement()) || event.defaultPrevented || event.isComposing ||
        event.altKey || event.ctrlKey || event.metaKey) return;
    if (event.key === 'Escape' && !event.shiftKey && !event.repeat) {
      event.preventDefault();
      event.stopImmediatePropagation();
      matchedClose(record).click();
    } else if (event.key === 'Tab') {
      event.preventDefault();
      event.stopImmediatePropagation();
      matchedClose(record).focus({ preventScroll: true });
    }
  }, true);
  document.addEventListener('visibilitychange', function () { records.forEach(queueRefresh); });
  document.addEventListener('close', function (event) {
    if (event.target && event.target.tagName === 'DIALOG') records.forEach(queueRefresh);
  }, true);
  document.addEventListener('dialog:before-show', function (event) {
    if (!dialogNode(event.target)) return;
    openingDialogs.add(event.target);
    records.forEach(conflictGate);
  }, true);
  document.addEventListener('dialog:after-hide', function (event) {
    openingDialogs.delete(event.target);
    records.forEach(queueRefresh);
  }, true);
  rememberEditor(activeElement());
  scan(document.documentElement);
  if (window.customElements && typeof window.customElements.whenDefined === 'function') {
    window.customElements.whenDefined('ct-web-popup-imageonly').then(function () {
      removeDetached();
      records.forEach(attachRoot);
    });
  }
})();
